<div class="group" [class.add-allowed]="addAllowed()" [class.vertical]="collapsed()">
  @if (addAllowed()) {
    <crm-select
      [options]="workspaces$"
      [showSearch]="true"
      [ngModel]="workspace()"
      (ngModelChange)="setWorkspace($event)"
    ></crm-select>
  }

  <div class="actions">
    @if (addAllowed()) {
      <button nz-button nzType="primary" nzSize="large" [nzBlock]="collapsed()" (click)="addWorkspace()">
        @if (collapsed()) {
          <span nz-icon nzType="plus"></span>
        } @else {
          {{ 'workspaces.add.title' | crmTranslate }}
        }
      </button>
    }

    <button nz-button nzType="default" nzSize="large" [nzBlock]="collapsed()" (click)="editWorkspace()">
      @if (collapsed()) {
        <span nz-icon nzType="edit"></span>
      } @else {
        {{ 'workspaces.edit.title' | crmTranslate }}
      }
    </button>
  </div>
</div>
